// All ingredient options for the gelato builder
export const STYLES = [
  { id: "dairy", label: "Dairy" },
  { id: "sorbet", label: "Sorbet" },
  { id: "vegan", label: "Vegan" },
  { id: "gluten-free", label: "Gluten-free" },
  { id: "sugar-free", label: "Sugar-free" },
  { id: "lactose-free", label: "Lactose-free" },
];

export const FRUITS = [
  "Acai", "Apple", "Apricot", "Avocado", "Banana",
  "Blackberry", "Blood Orange", "Blueberry", "Cantaloupe",
  "Chestnut", "Cherry", "Coconut", "Cranberry", "Date", "Dragon Fruit",
  "Fig", "Grape", "Grapefruit", "Guava", "Jackfruit",
  "Kiwi", "Korean Melon", "Korean Pear", "Kumquat", "Lemon",
  "Lime", "Licorice", "Lychee", "Mandarin", "Mango", "Mangosteen",
  "Orange", "Papaya", "Passion Fruit", "Peach",
  "Pear", "Persimmon", "Pineapple", "Plum", "Pomegranate",
  "Raspberry", "Starfruit", "Strawberry", "Tamarind", "Watermelon",
  "Yuzu",
];

export const CREAMS = [
  "Almond", "Cannoli Cream", "Cappuccino", "Caramel", "Cardamom",
  "Cheesecake", "Cinnamon", "Coconut Cream", "Coffee", "Cookies & Cream",
  "Crème Brûlée", "Custard Cream", "Dark Chocolate 50%", "Dark Chocolate 65%", "Dark Chocolate 75%",
  "Dark Chocolate 80%", "Dulce de Leche", "Espresso", "Fior di Latte", "Gianduja",
  "Green Tea", "Hazelnut", "Honey", "Honeydew", "Kinder Bueno",
  "Kinder Chocolate", "Kinder Country", "Maple", "Mascarpone", "Matcha",
  "Milk", "Milk Chocolate", "Nutella", "Nutella-style Hazelnut Cocoa", "Panettone",
  "Peanut Butter", "Pistachio", "Ricotta", "Salted Caramel", "Stracciatella",
  "Tiramisu", "Vanilla", "White Chocolate", "Yogurt", "Zabaglione",
];

export const CRAZY = [
  "Arugula", "Basil", "Black Truffle", "Camembert",
  "Carrots", "Celery", "Corn", "Cucumber", "Gorgonzola", "Kale", "Mint", "Mortadella",
  "Oil of Olive", "Parmigiano Reggiano", "Pumpkin", "Red Bean", "Red Pepper",
  "Rice", "Rosemary", "Sesame", "Smoked Salmon", "Spinach",
  "Tomatoes",
];

export const CRUNCHY = [
  "Oreo", "Lotus Biscoff", "Ladyfingers", "Hazelnuts", "Pistachios",
  "Peanuts", "Almonds", "Puffed Rice", "Chocolate Crumble", "Cookie Crumble",
  "Caramelized Peanuts", "Caramelized Almonds", "Pecan", "Raisins",
  "Brazil Nuts", "Lemon zest", "Lime zest", "Orange zest",
];

export const SWIRLS = [
  "Hazelnut", "Chocolate", "Almond", "Pistachio",
  "Caramel", "Raspberry", "Strawberry", "White Chocolate",
  "Amarena cherry", "Peanut butter",
];

export const SPICY = [
  "Turmeric", "Ginger", "Cayenne Pepper", "Black Pepper", "Cinnamon",
];

export const ALCOHOLS = ["Rum", "Whisky", "Cognac", "Prosecco", "Tequila"];

export const FUNCTIONAL = [
  { id: "energizing", label: "Energizing", desc: "A spark of vitality" },
  { id: "collagen", label: "Collagen", desc: "Beauty within" },
  { id: "anti-aging", label: "Anti-Aging", desc: "Timeless glow" },
  { id: "anti-stress", label: "Anti-Stress", desc: "Calm in every spoon" },
  { id: "relaxing", label: "Relaxing", desc: "Soft serenity" },
];

export const PICKUP_LOCATIONS = [
  "5241 Center Blvd, Long Island City, NY 11101",
  "227 West St, Brooklyn, NY 11222",
];
